var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterMultiselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23738_136432",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23738_136432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83333 13C6.3731 13 6 12.6269 6 12.1667C6 11.7064 6.3731 11.3333 6.83333 11.3333H9.16667C9.6269 11.3333 10 11.7064 10 12.1667C10 12.6269 9.6269 13 9.16667 13H6.83333ZM3.83333 8.83333C3.3731 8.83333 3 8.46024 3 8C3 7.53976 3.3731 7.16667 3.83333 7.16667H12.1667C12.6269 7.16667 13 7.53976 13 8C13 8.46024 12.6269 8.83333 12.1667 8.83333H3.83333ZM1.83333 4.66667C1.3731 4.66667 1 4.29357 1 3.83333C1 3.3731 1.3731 3 1.83333 3H14.1667C14.6269 3 15 3.3731 15 3.83333C15 4.29357 14.6269 4.66667 14.1667 4.66667H1.83333Z",
    fill: "#0E4C54"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterMultiselect);
export default __webpack_public_path__ + "static/media/filter-multiselect.36d60b543d7d8dd1355c6a466751bff3.svg";
export { ForwardRef as ReactComponent };